import { isIOS, isIpadOS } from './operatingSystem';

export const getTimestamp = (time, defaultDate) => {
  if (defaultDate !== '') {
    defaultDate = getDefaultDate();
  }
  const textDate = `${defaultDate && `${defaultDate} `}${time}`;
  return Date.parse(textDate);
};

export const getFormattedTimeUnit = timeUnit => timeUnit.toString().padStart(2, '0');

export const getDefaultDate = () => (isIOS() || isIpadOS() ? '1970/01/01' : '1970-01-01');
